import { apiFetch } from 'services/apiClient';
import { Page } from '../../../types/Page';
import { CreatePublicHolidayDto, PublicHoliday } from '../types/PublicHoliday';

export const listPublicHolidays = (
  page = 0,
  size = 10,
  sort?: string,
  query?: string,
): Promise<Page<PublicHoliday>> =>
  apiFetch('/public-holidays?page=' + page + '&size=' + size + (sort ? '&sort=' + sort : '') + (query ? '&' + query : ''));

export const listPublicHolidaysAll = (): Promise<PublicHoliday[]> => apiFetch('/public-holidays/all');

export const getPublicHoliday = (id: number): Promise<PublicHoliday> => apiFetch('/public-holidays/' + id);

export const createPublicHoliday = (data: CreatePublicHolidayDto): Promise<PublicHoliday> =>
  apiFetch('/public-holidays', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(data) });

export const updatePublicHoliday = (id: number, data: CreatePublicHolidayDto): Promise<PublicHoliday> =>
  apiFetch('/public-holidays/' + id, { method: 'PUT', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(data) });

export const deletePublicHoliday = (id: number): Promise<void> =>
  apiFetch('/public-holidays/' + id, { method: 'DELETE' });
